import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = ["src"]

import { ref, watch, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { checkMobile } from '../../utils/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'Meeting',
  setup(__props) {

const route = useRoute()
const mobile = ref(checkMobile())
const path = ref('')
const embed = ref<HTMLIFrameElement | null>(null)

onBeforeMount(() => {
  path.value = '/classroom/meeting' + window.location.hash.replace(/^#/, '')
})

watch(() => route, (to) => {
  path.value = '/classroom/meeting' + (to.hash || '').replace(/^#/, '')
}, { deep: true })

const embedLoad = () => {
  if (!embed.value) return
  const embedPath = (embed.value as any).contentWindow?.location.href || ''
  if (embedPath.endsWith('bookings')) {
    return
  }
  const match = embedPath.match(/\/classroom\/meeting(.*)/)
  if (match) {
    window.location.hash = match[1]
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      ref_key: "embed",
      ref: embed,
      src: path.value,
      style: _normalizeStyle(`width: 100%; min-height: calc(100vh - ${mobile.value ? 50 : 70}px)`),
      onLoad: embedLoad
    }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_2)
  ]))
}
}

})